import isEmpty from "lodash/isEmpty"
import { ifBoolParse, isEmptyString } from "heliocor-ui"
import { translateChecker } from "./translateChecker"

const documentFields = {
    PASSPORT: [
        { value: "NAME" },
        { value: "SURNAME" },
        { value: "COUNTRY_OF_ISSUE" },
        { value: "DOCUMENT_NUMBER" },
        { value: "DATE_OF_BIRTH" },
        { value: "NATIONALITY", id: "country", subCat: "countries" },
        { value: "GENDER", id: "gender" },
        { value: "DATE_OF_EXPIRATION" },
    ],
    ID_CARD: [
        { value: "NAME" },
        { value: "SURNAME" },
        { value: "COUNTRY_OF_ISSUE" },
        { value: "DOCUMENT_NUMBER" },
        { value: "DATE_OF_BIRTH" },
        { value: "GENDER", id: "gender" },
        { value: "DATE_OF_EXPIRATION" },
    ],
    SELFIE: [{ value: "AGE_HIGH" }, { value: "AGE_LOW" }],
    VIDEO_SELFIE: [
        { value: "GENDER" },
        { value: "AGE_HIGH" },
        { value: "AGE_LOW" },
    ],
    DRIVING_LICENCE: [
        { value: "NAME" },
        { value: "SURNAME" },
        { value: "COUNTRY_OF_ISSUE" },
        { value: "DOCUMENT_NUMBER" },
        { value: "DATE_OF_EXPIRATION" },
        { value: "DATE_OF_ISSUE" },
        { value: "ISSUER" },
        { value: "PLACE_OF_BIRTH" },
        { value: "DATE_OF_BIRTH" },
    ],
}

const getUploadedDocumentsData = (category, uploadedDocuments = []) => {
    const validUploadedDocuments = uploadedDocuments.filter((doc) =>
        isValidUploadedDocument(doc, category)
    )
    const numberOfCategoryDocuments = category?.documents?.length || 0
    const numberOfValidUploadedDocuments = validUploadedDocuments.length
    const numberOfDocsToUpload =
        category.minDocuments - numberOfValidUploadedDocuments

    const localeKey =
        numberOfCategoryDocuments === 1
            ? "pleaseUploadTheDoc"
            : numberOfValidUploadedDocuments > 0
            ? "pleaseUploadRemainingMinDocs"
            : "pleaseUploadMinDocs"

    return {
        localeKey,
        numberOfDocsToUpload,
    }
}

const hasErrors = (document = {}) => {
    const { errors, sentForManualValidation } = document
    return (
        !!errors &&
        !sentForManualValidation &&
        !errors.includes("NOT_VALIDATED")
    )
}

const isValidUploadedDocument = (document, category) => {
    return (
        (!isEmpty(document.datas) || document.request) &&
        document.category === category.code &&
        (document.sentForManualValidation ||
            !document.errors ||
            document.errors.includes("NOT_VALIDATED"))
    )
}

const isUploadAvailable = (maxFiles, currentFiles = []) => {
    return !maxFiles || maxFiles > currentFiles.length
}

const translateDocTitle = (doc) => {
    return translateChecker(doc.name, null, "docs")
}

const getFilteredProperties = (document) => {
    let documentData = []

    if (document.category === "PROOF_ADDRESS") {
        document.reasons &&
            document.reasons.includes("ADDRESS_GOOGLE_VALID") &&
            ["FORMATTED_ADDRESS", "date"]
                .filter((field) =>
                    ({ ...document }.properties.find((f) => f.name === field))
                )
                .map((field) =>
                    documentData.push({
                        [field]: { ...document }.properties.find(
                            (f) => f.name === field
                        ).value,
                    })
                )
    } else {
        documentFields[document.type]
            .filter((field) =>
                ({ ...document }.properties.find(
                    (f) => f.name === field.value && !isEmptyString(f.value)
                ))
            )
            .map((field) => {
                const val = { ...document }.properties.find(
                    (f) => f.name === field.value
                ).value
                return documentData.push({
                    [field.value]: field.id
                        ? translateChecker(val, undefined, field.subCat)
                        : val,
                })
            })
    }
    return documentData
}

const isDocumentVisible = (document = {}, values = {}, fieldsConfig) => {
    const dependency = JSON.parse(document?.options || '{}')

    const { field, type } = dependency

    if (!field || !fieldExists(field, fieldsConfig)) return true

    const value = values[field]?.value || values[field]

    switch (type) {
        case 'SELECT':
            return Array.isArray(value)
                ? value.some(v => dependency.values.includes(v))
                : dependency.values.includes(value)
        case 'BOOLEAN':
            return dependency.values?.some(v => ifBoolParse(v) === value)
        default:
            return true
    }
}

const fieldExists = (field, fieldsConfig) => fieldsConfig?.some(f => field.id === field)

export {
    hasErrors,
    getUploadedDocumentsData,
    isUploadAvailable,
    isDocumentVisible,
    isValidUploadedDocument,
    getFilteredProperties,
    translateDocTitle,
}
